module.exports = __webpack_public_path__ + "img/bcp.1c0f563b.svg";